export const checkGraphQLHealth = async (options = {}) => {
  const { detailed = false, timeout = 8000 } = options;

  const buildResult = (online, version) =>
    detailed
      ? version
        ? { online, version }
        : { online }
      : online;

  const endpoint = process.env.REACT_APP_GRAPHQL_SERVER;
  if (!endpoint) return buildResult(false);

  let healthUrl;
  try {
    healthUrl = `${new URL(endpoint).origin}/health`;
  } catch {
    return buildResult(false);
  }

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeout);

  try {
    const response = await fetch(healthUrl, {
      method: 'GET',
      signal: controller.signal,
    });

    if (!response.ok) {
      console.warn(
        `[HealthCheck] Server responded with status ${response.status}`,
      );
      return buildResult(false);
    }

    if (!detailed) return buildResult(true);

    try {
      const body = await response.json();
      return buildResult(true, body?.version);
    } catch {
      return buildResult(true);
    }
  } catch (error) {
    if (error.name === 'AbortError') {
      console.warn(
        `[HealthCheck] Server did not respond within ${timeout}ms`,
      );
    }
    return buildResult(false);
  } finally {
    clearTimeout(timeoutId);
  }
};
